import React, { useState, useEffect } from 'react'
import { Button, Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'

export default function Reservations() {

  const [createNewFlag, setCreateNewFlag] = useState(false)
  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('');

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role === 'SuperAdmin') {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['Reservations_Access Specifier']);
    }

  }, []);


  return (
    <>

      <div className="row">

        <div className="row my-3 ">
          <div className="col-md-6">
            <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
              Reservations {accessType === 'View' ? " / View Only Mode" : ""}
            </Typography>
          </div>
          <div className="col-md-6 d-flex justify-content-end"   >

            <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="example-modal-sizes-title-lg"

            >
              <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                <Modal.Title id="example-modal-sizes-title-lg" >
                  Instructions to view Reservations
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ol>
                  <li>Select the  Account Name from the dropdown</li>
                  <li>Select the location name from the location name dropdown
                  </li>
                  <li>Slect the car class
                  </li>
                  <li>Filter the reservations based on Booked Date, DropOff Date and PickUpDate

                  </li>
                  <li>Filter the booking status by selecting All, Valid, Cancelled, No Show from the dropdown
                  </li>
                  <li>Select From Date To Date from the calendar and click on fetch
                  </li>
                </ol>

                <h5>Existing Reservations:
                </h5>
                <ul>
                  <li>To view the reservation details select Account Name Location Name and filtre based  on car class, booking status and the date range.

                  </li>
                </ul>

              </Modal.Body>
            </Modal>

          </div>
        </div>


        {/* <div className="col-4 d-flex justify-content-end px-5">
        
          
         
        </div> */}

      </div>

      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}

    </>
  );
}
